import Vue from 'vue'
import Vuex from 'vuex'
import appcurrent from './modules/appcurrent'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appcurrent
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js